import { render } from "./SDKDownload.vue?vue&type=template&id=4f353dee&scoped=true"
import script from "./SDKDownload.vue?vue&type=script&lang=js"
export * from "./SDKDownload.vue?vue&type=script&lang=js"

import "./SDKDownload.vue?vue&type=style&index=0&id=4f353dee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f353dee"]])

export default __exports__